import { Injectable } from '@angular/core';
import {Status} from '../../../../services/enums/status.enum';
import {CacStateEnum} from '../../../../services/enums/cac-state.enum';
@Injectable({
  providedIn: 'root'
})
export class DiagramMappersUtilsService {

  connectionStatusByLayer(dataItem, layerName): string {
    switch (layerName) {
      case 'topology': return connectionStatusTopologyLayer(dataItem);
      case 'quality' : return connectionStatusQualityLayer(dataItem);
      default: return Status.GOOD;
    }

    function connectionStatusTopologyLayer(data): string {
      const connections = data.connections;

      if (data.type === 'NODE_TO_THIRD_PARTY') {
        return connections[0].operState === 'AVAILABLE' ? Status.GOOD : Status.BAD;
      } else {
        if (connections[0] && connections[1] && connections[0].operState === 'AVAILABLE'
            && connections[1].operState === 'AVAILABLE') {
          return Status.GOOD;
        } else {
          return Status.BAD;
        }
      }
    }

    function connectionStatusQualityLayer(data): string {
      switch (data.result) {
        case 'BAD': return Status.BAD;
        case 'FAIR': return Status.MEDIUM;
        case 'GOOD': return Status.GOOD;
        case 'UNKNOWN': return Status.UNKNOWN;
        default: return Status.GOOD;
      }
    }
  }

  peerConnectionStatusByLayer(dataItem, layerName): string {
    switch (layerName) {
      case 'topology': return this.peerConnectionStatusTopologyLayer(dataItem);
      case 'quality' : return this.peerConnectionStatusQualityLayer(dataItem);
      case 'quota': return this.peerConnectionStatusQuotaLayer(dataItem);
      case 'cac': return this.peerConnectionStatusCacLayer(dataItem);
    }
  }

  private peerConnectionStatusTopologyLayer(data): string {
    if (data.operState !== 'AVAILABLE') {
      return Status.BAD;
    } else {
      return Status.GOOD;
    }
  }

  private peerConnectionStatusQualityLayer(data): string {
    switch (data.result) {
      case 'BAD': return Status.BAD;
      case 'FAIR': return Status.MEDIUM;
      case 'GOOD': return Status.GOOD;
      case 'UNKNOWN': return Status.UNKNOWN;
      default: return Status.GOOD;
    }
  }

  private peerConnectionStatusQuotaLayer(data): string {
    if (data.quotaState === 'BLOCK_OUTGOING') {
      return Status.BAD;
    } else if (data.quotaLimitReached) {
      return Status.MEDIUM;
    } else if (data.quotaWarningReached) {
      return Status.BLOCKED;
    }

    return Status.GOOD;
  }

  private peerConnectionStatusCacLayer(data): string {
    if (data.cacState === CacStateEnum.BLOCK ||
        data.cacState === CacStateEnum.BLOCK_INCOMING ||
        data.cacState === CacStateEnum.BLOCK_OUTGOING) {
      return Status.BAD;
    }

    return Status.GOOD;
  }
}
